import { Page } from '@/core/architecture'

import { AutoFollowSettingsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * AutoFollowSettings Page
 * Implemented as a practical sample.
 */
export const AutoFollowSettings: Page = () => {
  const { state, actions } = useViewModel()

  return <AutoFollowSettingsTemplate state={state} {...actions} />
}
